<template>
  <div class="page-content">
    <page-template ref="mgmtTemplate"
                   :tableOptions="tableOptions"
                   :searchOptions="searchOptions"
                   :toolConfig="toolConfig"
                   :addColumns="addColumns"
                   :editColumns="editColumns"
                   @getDetail="getDetail"
    ></page-template>
  </div>
</template>

<script>
  import pageTemplate from '@/components/template/pageTemplate';
  import api from '@/config/api';

  export default {
    components: {
      pageTemplate

    },
    data() {
      return {
        dialogVisibility: false,
        // 搜索条件
        searchOptions: {
          simple: [
            {
              label: '门店编码/名称',
              prop: 'otherName',
              type: 'input',
              isFuzzy: true,
              placeholder: '请输入门店编码/名称',
              labelWidth: '110'
            },
          ]
        },

        // 更多功能
        toolConfig: [
          {
            label: '新增',
            code: 'insert',
          },
          {
            label: '主店设置',
            code: 'mainStore',
            callback: this.mainStore,
            filter: () => {
              return false
            }
          },
          {
            label: '闭店管理',
            code: 'closeStore',
            callback: this.closeStore,
            filter: () => {
              return false
            }
          },
          {
            label: '信息管理',
            type: this.$utils.buttonType.tableOperate,
            code: 'update'
          },
          {
            label: '门店二维码',
            type: this.$utils.buttonType.tableOperate,
            code: 'storeQrCode',
            filter: () => {
              return false
            }
          },
          {
            label: "达达配送",
            type: this.$utils.buttonType.tableOperate,
            code: 'daDaDistribution',
            filter: () => {
              return false
            }
          },
          {
            label: "进件码下载",
            type: this.$utils.buttonType.tableOperate,
            code: 'downloadQrCode',
            callback: this.downloadQrCode,
            filter: (data) => {
              return data.storeClass === 2
            }
          },
          // {
          //   label: '闭店管理',
          //   code: 'daDaDistribution',
          //   callback: this.daDaDistribution
          // },
        ],
        // 表格信息配置
        tableOptions: {
          showSelect: true,
          indexShow: true,//是否显示索引
          indexMethod: (index) => {//自定义列索引
            return index + 1;
          },
          columns: [
            {
              label: '门店编码',
              prop: 'code',
              width: '70',
              align: 'center',
            },
            {label: '门店名称', prop: 'name', width: '90', align: 'center'},
            {
              label: '门店类型',
              prop: 'storeClass',
              width: '60',
              align: 'center',
              enumData: this.$utils.getCacheStatus('seStore.storeClass')
            },
            // {
            //   label: '状态',
            //   prop: 'status',
            //   width: '60',
            //   align: 'center',
            //   enumData: this.$utils.getCacheStatus('seStore.status')
            // },
            // {
            //   label: '门店图片',
            //   prop: 'headImg',
            //   width: '60',
            //   align: 'center',
            //   type: 'image'
            // },
            {
              label: '营业状态',
              prop: 'businessStatus',
              width: '60',
              align: 'center',
              enumData: this.$utils.getCacheStatus('seStore.businessStatus')
            },
            {label: '联系人', prop: 'contact', width: '80', align: 'center'},
            {
              label: '联系方式',
              prop: 'phone',
              width: '100',
              align: 'center',
            },
            {
              label: '门店地址',
              prop: 'detailAddress',
              width: '130',
              align: 'center',
            },
            // {
            //   label: '店铺类型',
            //   prop: 'type',
            //   width: '60',
            //   enumData: this.$utils.getCacheStatus("seStore.type"),
            //   align: 'center',
            // },
          ],
          url: api.store.store
        },
        // 添加字段
        addColumns: {
          labelWidth: '130px',
          span: 12,
          columns: [
            {
              label: '后端所需字段',
              prop: 'openDada',
              width: '70',
              align: 'center',
              hidden: true
            },
            // {
            //   label: '门店编码',
            //   type: 'input',
            //   prop: 'code',
            //   placeholder: "请输入门店编码",
            //   disabled:true,
            // },
            {
              label: '门店名称',
              type: 'input',
              prop: 'name',
              placeholder: "请输入门店名称",
              rule: [
                {required: true, message: '请输入门店名称', trigger: 'blur'},
              ],
              change: this.checkName
            },

            {
              label: '营业状态',
              prop: 'openBusiness',
              type: 'switch',
              activeValue: true,
              inactiveValue: false,
              defaultValue: true,
            },
            {
              label: '门店类型',
              type: 'select',
              prop: 'storeClass',
              defaultValue: 1,
              data: this.$utils.getCacheStatus("seStore.storeClass"),
              change: this.storeTypeChange,
              rule: [
                {required: true, message: '请选择门店类型', trigger: 'blur'},
              ]
            },
            {
              label: '是否同步总部商品',
              prop: 'syncMerchantGoods',
              type: 'switch',
              activeValue: true,
              inactiveValue: false,
              defaultValue: false,
              hidden: true
            },
            {
              label: '联系人',
              type: 'input',
              prop: 'contact',
              placeholder: "请输入联系人",
            },
            {
              prop: 'type',
              hidden: true,
              defaultValue: 1
            },
            {
              label: '联系方式',
              type: 'input',
              prop: 'phone',
              placeholder: "请输入手机号",
              maxLength: 11,
              rule: [
                {pattern: this.$utils.reg.phone, message: '请输入正确的手机号', trigger: 'blur'}
              ]
            },
            {
              label: '门店地址',
              type: 'casaderSelect',
              prop: 'province',
              span: 24,
              // specialRule: [{required: true}],
              casaderOptions: [{
                prop: 'province',
                data: [],
                childProps: 'city',
                param: {parentId: 0},
                url: api.getAreaList,
              }, {
                prop: 'city',
                data: [],
                childProps: 'area',
                url: api.getAreaList,
              }, {
                prop: 'area',
                data: [],
                url: api.getAreaList,
              }]
            },
            {
              label: "详细地址",
              type: "input",
              prop: "detailAddress",
              span: 24,
            },
            {
              label: "商户号",
              type: "mchntNo",
              prop: 'mchntNo',
            },
            // {
            //   label: "经度",
            //   type: "inputNumber",
            //   prop: "longitude",
            //   max: 180,
            //   min: -180,
            //   precision: 5,
            //   disabled:true,
            //   rule: [{required: true, message: "请选择经度！"}]
            // },
            // {
            //   label: "纬度",
            //   type: "inputNumber",
            //   prop: "latitude",
            //   max: 90,
            //   min: -90,
            //   precision: 5,
            //   disabled:true,
            //   rule: [{required: true, message: "请选择纬度！"}]
            // },
            // {
            //   label: '',
            //   type: 'map',
            //   prop: 'map',
            //   span: 24,
            //   lat: 'latitude',
            //   lon: 'longitude',
            //   labelWidth: 120,
            // },
            // {
            //   label: '门店照片',
            //   type: 'image',
            //   prop: 'headImg',
            //   limit: 10,
            //   //callback: this.setImageData,
            //   //rule: [{required: true, message: "请上传门店照片！"}]
            // },
            // {
            //   label: '达达配送',
            //   prop: 'openDada',
            //   type: 'switch',
            //   activeValue: true,
            //   inactiveValue: false,
            //   span: 24,
            //   change: this.dadaChange
            // },
            // {
            //
            //   label: '以下是达达配送所需提交项可选填',
            //   prop: 'dada',
            //   type: 'title',
            //   span: 24,
            //   hidden: true,
            // },
            // {
            //   label: '门店类型',
            //   type: 'select',
            //   prop: 'businessId',
            //   span: 24,
            //   hidden: true,
            //   data: this.$utils.getCacheStatus("seStore.businessId"),
            //   rule: [
            //     {required: true, message: '请选择门店类型', trigger: 'blur'},
            //   ]
            // },
            // {
            //   label: '达达商家app账号',
            //   prop: 'dadaUserName',
            //   type: 'input',
            //   hidden: true,
            //   span: 24,
            //   placeholder: "商家app账号(若不需要登录app,则不需要设置)"
            // },
            // {
            //   label: '达达商家app密码',
            //   prop: 'dadaPassWord',
            //   type: 'input',
            //   span: 24,
            //   hidden: true,
            //   placeholder: "商家app密码(英文和数字两种拼接若不需要登录app,则不需要设置)"
            // },
          ],
          url: api.store.store,
          saveConditions: null,
        },
        // 编辑字段
        editColumns: {
          labelWidth: '130px',
          span: 12,
          columns: [
            {
              label: '后端所需字段',
              prop: 'openDada',
              width: '70',
              align: 'center',
              hidden: true
            },
            {
              label: '门店编码',
              type: 'input',
              prop: 'code',
              placeholder: "请输入门店编码",
              disabled: true,
              span: 24,
              // rule: [
              //   {required: true, message: '请输入门店编码', trigger: 'blur'},
              // ]
            },
            {
              label: '门店名称',
              type: 'input',
              prop: 'name',
              placeholder: "请输入门店名称",
              rule: [
                {required: true, message: '请输入门店名称', trigger: 'blur'},
              ],
              change: this.checkNameEdit
            },
            {
              label: '营业状态',
              prop: 'openBusiness',
              type: 'switch',
              activeValue: true,
              inactiveValue: false,
              span: 12,
            },
            {
              label: '门店类型',
              type: 'select',
              prop: 'storeClass',
              data: this.$utils.getCacheStatus("seStore.storeClass"),
              disabled: true,
              change: this.storeTypeChange,
              rule: [
                {required: true, message: '请选择门店类型', trigger: 'blur'},
              ]
            },
            {
              label: '是否同步总部商品',
              prop: 'syncMerchantGoods',
              type: 'switch',
              activeValue: true,
              inactiveValue: false,
              defaultValue: false,
              disabled: true,
              hidden: true,
            },
            {
              label: '联系人',
              type: 'input',
              prop: 'contact',
              placeholder: "请输入联系人",
            },
            {
              prop: 'type',
              hidden: true,
              defaultValue: 1
            },
            {
              label: '联系方式',
              type: 'input',
              prop: 'phone',
              placeholder: "请输入手机号",
              maxLength: 11,
              rule: [
                {pattern: this.$utils.reg.phone, message: '请输入正确的手机号', trigger: 'blur'}
              ]
            },

            {
              label: '门店地址',
              type: 'casaderSelect',
              prop: 'province',
              span: 24,
              // specialRule: [{required: true}],
              casaderOptions: [{
                prop: 'province',
                data: [],
                childProps: 'city',
                param: {parentId: 0},
                url: api.getAreaList,
              }, {
                prop: 'city',
                data: [],
                childProps: 'area',
                url: api.getAreaList,
              }, {
                prop: 'area',
                data: [],
                url: api.getAreaList,
              }]
            },
            {
              label: "详细地址",
              type: "input",
              prop: "detailAddress",
              span: 24,
            },
            {
              label: "商户号",
              type: "mchntNo",
              prop: 'mchntNo',
            },
          ],
          url: api.store.store,
          saveConditions: null,
        },
        isReaptName: false,
      };
    },
    created() {
    }
    ,
    methods: {
      // 选择门店类型
      storeTypeChange(form) {
        let syncMerchantGoods = this.addColumns.columns.filter((v) => v.prop === 'syncMerchantGoods')[0]
        if (form.storeClass === 2) {
          syncMerchantGoods.hidden = false
        } else {
          syncMerchantGoods.hidden = true
        }
      },
      getDetail(val) {
        this.editData = this.$utils.deepClone(val);
      },
      checkFun(name) {
        return new Promise((resolve, reject) => {
          this.$axios.fetchGet(api.archives.storeName + '?storeName=' + name, {}).then(res => {
            this.loading = false;
            if (res.code == 200) {
              if (!res.data) {
                this.$message({type: 'warning', message: '名称重复'});
                this.isReaptName = false
              } else if (name === '总部') {
                this.$message({type: 'warning', message: '门店名称不能为"总部"'});
                this.isReaptName = false
              } else {
                this.isReaptName = true
              }
              resolve(this.isReaptName)
            } else {
              reject()
              this.$message({type: 'error', message: res.msg});
            }
          }).catch(err => {
          })
        })
      },
      // 新增 校验名称重复
      checkName(val) {
        this.checkFun(val.name).then(() => {
          if (!this.isReaptName) {
            val.name = ''
          }
          this.addColumns.saveConditions = !this.isReaptName//提交接口之前的判断条件
        })
      },
      // 编辑 校验名称重复
      checkNameEdit(val) {
        if (this.editData.name && this.editData.name != val.name) {
          this.checkFun(val.name).then(() => {
            if (!this.isReaptName) {
              val.name = this.editData.name
            }
            this.editColumns.saveConditions = !this.isReaptName//提交接口之前的判断条件
          })
        }
      },
      setImageData(formModel, fileList) {
        formModel.headImg = fileList[0].response;
      },
      mainStore() {
        let tableSelected = this.$refs.mgmtTemplate.getTableSelectRow();
        if (tableSelected.length === 0) {
          this.$message({message: '请选择一个门店进行主店设置', type: 'warning'});
        } else if (tableSelected.length > 1) {
          this.$message({message: '主店设置只能选择一个门店', type: 'warning'});
          this.$refs.mgmtTemplate.clearSearch();
        } else {
          this.$axios.fetchPost(api.store.mainStore, tableSelected[0]).then(data => {
            if (data.code === 200) {
              this.loading = true;
              this.$notify({
                type: "success",
                title: '主店设置操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({message: '主店设置成功', type: 'success'});
              this.$refs.mgmtTemplate.operationSuccess();
            } else {
              this.message({message: data.msg, type: 'error'})
            }
          })
        }
      },
      closeStore() {
        let tableSelected = this.$refs.mgmtTemplate.getTableSelectRow();
        if (tableSelected.length === 0) {
          this.$message({message: '请至少选择一个门店进行闭店设置', type: 'warning'});
        } else {
          this.$axios.fetchPost(api.store.closeStore, {seStoreList: tableSelected}).then(data => {
            if (data.code === 200) {
              this.loading = true;
              this.$notify({
                type: "success",
                title: '闭店设置操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({message: '闭店设置成功', type: 'success'});
              this.$refs.mgmtTemplate.operationSuccess();
            } else {
              this.message({message: data.msg, type: 'error'});
            }
          })
        }
      },

      daDaDistribution(row) {
        this.$axios.fetchPost(api.store.syncData, row).then(data => {
          if (data.code === 200) {
            this.$notify({
              type: "success",
              title: '同步操作',
              message: '成功',
              showClose: false,
            });
            // this.$message({message: '同步成功', type: 'success'});
          } else {
            this.$message({message: data.data.errorMsg, type: 'error'});
          }
        })
      },
      dadaChange(row) {
        if (row.openDada === true) {
          this.addColumns.columns.filter(item => item.prop === 'dada')[0].hidden = false;
          this.addColumns.columns.filter(item => item.prop === 'businessId')[0].hidden = false;
          this.addColumns.columns.filter(item => item.prop === 'dadaUserName')[0].hidden = false;
          this.addColumns.columns.filter(item => item.prop === 'dadaPassWord')[0].hidden = false;
        } else {
          this.addColumns.columns.filter(item => item.prop === 'dada')[0].hidden = true;
          this.addColumns.columns.filter(item => item.prop === 'businessId')[0].hidden = true;
          this.addColumns.columns.filter(item => item.prop === 'dadaUserName')[0].hidden = true;
          this.addColumns.columns.filter(item => item.prop === 'dadaPassWord')[0].hidden = true;
        }
      },
      downloadQrCode(form) {
        let sysUser = this.$utils.getSysUser();
        this.$axios.fetchGet(api.store.downloadQrCode + "?merchantId="
          + sysUser.merchantId + "&relateCode="
          + form.retaleCode + "&relateType=" + 20).then(data => {
          if (data.code === 200) {
            const a = document.createElement('a')
            a.href = data.data;
            a.setAttribute('download', form.name + '进件码.png');
            a.click()
          } else {
            this.$message.error("下载进件码异常")
          }
        })
      }
    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/store/Mgmt.vue